import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Star, ShieldCheck, ArrowRight, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ModernDentalExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="23592" id="affordable-smiles-for-el-monte" className="relative overflow-hidden bg-background pt-12 pb-20 lg:pt-24 lg:pb-32">
      {}
      <div className="absolute top-0 right-0 -z-10 h-[600px] w-[600px] translate-x-1/3 -translate-y-1/4 rounded-full bg-secondary/50 blur-3xl" />
      <div className="absolute bottom-0 left-0 -z-10 h-[400px] w-[400px] -translate-x-1/3 translate-y-1/4 rounded-full bg-accent/20 blur-3xl" />

      <div className="container mx-auto px-4">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-center lg:gap-8">
          {}
          <div ref={ref} className={`lg:col-span-7 flex flex-col items-start text-left transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <Badge variant="outline" className="mb-6 border-accent/30 bg-accent/10 px-4 py-1.5 text-sm text-accent-foreground backdrop-blur-sm">
              <span className="mr-2 inline-block h-2 w-2 rounded-full bg-accent-foreground animate-pulse" />
              El Monte&apos;s #1 Choice
            </Badge>

            <h1 className="font-serif text-5xl font-medium leading-[1.1] tracking-tight !text-[hsl(86,78%,27%)] sm:text-6xl lg:text-7xl xl:text-8xl">Make the Smart Choice</h1>

            <p className="mt-6 max-w-2xl text-lg text-muted-foreground sm:text-xl leading-relaxed font-sans">At Smart Choice Denture &amp; Implants, we specialize in affordable dentures, dental implants, and IV sedation dentistry in El Monte, CA. Whether you need same-day dentures, full mouth dental implants, or tooth extractions, our team provides comfortable, efficient care. <br /><br />We proudly serve patients throughout the San Gabriel Valley looking for affordable, stress-free tooth replacement.</p>

            <div className="mt-10 flex flex-wrap gap-4">
              <Button asChild size="lg" className="h-14 px-8 text-base rounded-full shadow-lg shadow-primary/20 transition-transform hover:-translate-y-0.5 bg-primary text-primary-foreground">
                <Link to="/ContactUsPage">
                  <SafeHydrate><Calendar className="mr-2 h-5 w-5" /></SafeHydrate>
                  Book Consultation
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base rounded-full border-primary/20 bg-transparent text-primary hover:bg-secondary hover:text-primary transition-transform hover:-translate-y-0.5">
                
              </Button>
            </div>

            <div className="mt-12 flex items-center gap-4 text-sm text-muted-foreground">
              
              <div className="flex flex-col">
                <div className="flex items-center gap-1 text-accent-foreground">
                  <Star className="h-4 w-4 fill-current" />
                  <Star className="h-4 w-4 fill-current" />
                  <Star className="h-4 w-4 fill-current" />
                  <Star className="h-4 w-4 fill-current" />
                  <Star className="h-4 w-4 fill-current" />
                </div>
                <span className="font-medium text-foreground">Serving San Gabriel Valley Families</span>
              </div>
            </div>
          </div>

          {}
          <div className="relative lg:col-span-5 lg:h-auto">
            <div className="relative mx-auto max-w-md lg:max-w-none">
              {}
              <div className="relative aspect-[4/5] w-full overflow-hidden rounded-[2.5rem] shadow-2xl shadow-primary/5 ring-1 ring-black/5">
                <img src="https://proud-garfish.10web.cloud/wp-content/uploads/2026/04/happy_senior_lady_smile.webp" alt="Happy patient with a perfect smile" className="h-full w-full object-cover object-center transition-transform duration-700 hover:scale-105" />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/10 to-transparent opacity-0 transition-opacity duration-500 hover:opacity-100" />
              </div>

              {}
              <div className="absolute -left-6 top-12 animate-bounce [animation-duration:3s]">
                <div className="flex items-center gap-3 rounded-2xl bg-card/95 p-4 shadow-xl backdrop-blur-md ring-1 ring-black/5">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-accent text-accent-foreground">
                    <Star className="h-5 w-5 fill-current" />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-foreground">Same-Day Care</p>
                    <p className="text-xs text-muted-foreground">Efficient service</p>
                  </div>
                </div>
              </div>

              {}
              <div className="absolute -right-6 bottom-20 animate-bounce [animation-duration:4s] [animation-delay:1s]">
                <div className="flex items-center gap-3 rounded-2xl bg-card/95 p-4 shadow-xl backdrop-blur-md ring-1 ring-black/5">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
                    <ShieldCheck className="h-5 w-5" />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-foreground">Top Rated</p>
                    <p className="text-xs text-muted-foreground">Expert clinical team</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}